import type { Permission } from './permissions';

export type NavItem = {
  text: string;
  url: string;
  requiredPermission: Permission;
  featureFlag?: string; // key in Env that must be truthy
};

export const NAV_ITEMS: NavItem[] = [
  { text: 'Werklijnen', url: '/', requiredPermission: 'mwd.view' },
  { text: 'B-regelingen', url: '/b-regelingen', requiredPermission: 'bregelingen.view' },
  { text: 'Plank', url: '/plank', requiredPermission: 'ddp.view' },
  { text: 'Agenda', url: '/agenda', requiredPermission: 'agenda.view', featureFlag: 'featureAgenda' },
  { text: 'LMM', url: '/lmm', requiredPermission: 'lmm.view', featureFlag: 'featureLmm' },
];
